(function () {
  'use strict';

  const API_BASE = '/apps/tecdoc';
  const STORAGE_KEY = 'vehicle_fitment_vehicle';

  const $ = (root, selector) => root ? root.querySelector(selector) : null;
  const $$ = (root, selector) => root ? Array.from(root.querySelectorAll(selector)) : [];

  function esc(value) {
    return String(value || '')
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;');
  }

  function field(item, names) {
    for (const name of names) {
      if (item && item[name] != null) return item[name];
    }
    return '';
  }

  function translate(value) {
    return window.GarageVehicleLabels && window.GarageVehicleLabels.translateText
      ? window.GarageVehicleLabels.translateText(value)
      : String(value || '');
  }

  function vehicleId(vehicle) {
    return field(vehicle, ['vehicleId', 'VehicleId', 'id', 'Id']);
  }

  function vehicleName(vehicle) {
    return [
      field(vehicle, ['makeName', 'MakeName']),
      translate(field(vehicle, ['modelName', 'ModelName'])),
      translate(field(vehicle, ['typeName', 'TypeName']))
    ].filter(Boolean).join(' ');
  }

  function vehicleMeta(vehicle) {
    return [
      field(vehicle, ['engineCode', 'EngineCode']),
      field(vehicle, ['powerHp', 'PowerHp']) ? `${field(vehicle, ['powerHp', 'PowerHp'])} hp` : '',
      field(vehicle, ['yearFrom', 'YearFrom'])
    ].filter(Boolean).join(' | ');
  }

  function vehicleImage(vehicle) {
    return field(vehicle, ['imageUrl', 'ImageUrl']);
  }

  function api(root, path, extra) {
    const params = new URLSearchParams({
      storeId: root.dataset.storeId || 'injecteurgarage',
      tecDocProfile: root.dataset.tecDocProfile || 'fr',
      lang: root.dataset.language || 'fr',
      family: root.dataset.family || 'injecteurs',
      ...(extra || {})
    });

    return fetch(`${API_BASE}${path}?${params.toString()}`, { headers: { Accept: 'application/json' } })
      .then(async (response) => {
        const json = await response.json().catch(() => null);
        if (!response.ok || !json || json.success === false) {
          throw new Error((json && json.error) || `Requête impossible (${response.status})`);
        }
        return json.data || [];
      });
  }

  function readVehicle(root) {
    const storeId = root.dataset.storeId || 'injecteurgarage';
    const tecDocProfile = root.dataset.tecDocProfile || 'fr';

    try {
      const vehicle = JSON.parse(localStorage.getItem(STORAGE_KEY) || 'null');
      if (!vehicle) return null;
      if (vehicle.storeId !== storeId) return null;
      const savedProfile = vehicle.tecDocProfile || vehicle.profile;
      if (savedProfile !== tecDocProfile) return null;
      return vehicleId(vehicle) ? vehicle : null;
    } catch (_) {
      return null;
    }
  }

  function saveVehicle(root, vehicle) {
    const rawVehicleId = vehicleId(vehicle);
    const numericVehicleId = rawVehicleId === '' || rawVehicleId == null ? '' : Number(rawVehicleId);
    const payload = {
      ...vehicle,
      id: Number.isFinite(numericVehicleId) ? numericVehicleId : rawVehicleId,
      storeId: root.dataset.storeId || 'injecteurgarage',
      tecDocProfile: root.dataset.tecDocProfile || 'fr',
      family: root.dataset.family || 'injecteurs',
      savedAt: Date.now()
    };

    localStorage.setItem(STORAGE_KEY, JSON.stringify(payload));
    document.dispatchEvent(new CustomEvent('vehiclefitment:selected', { detail: payload }));
    return payload;
  }

  function clearVehicle() {
    localStorage.removeItem(STORAGE_KEY);
    document.dispatchEvent(new CustomEvent('vehiclefitment:cleared'));
  }

  function resultsUrl(root, vehicle) {
    const target = root.dataset.resultsUrl || '/pages/compatibilite-vehicule';
    const url = new URL(target, window.location.origin);
    url.searchParams.set('vehicleId', String(vehicleId(vehicle)));
    url.searchParams.set('storeId', root.dataset.storeId || 'injecteurgarage');
    url.searchParams.set('tecDocProfile', root.dataset.tecDocProfile || 'fr');
    url.searchParams.set('family', vehicle.family || root.dataset.family || 'injecteurs');
    return `${url.pathname}${url.search}`;
  }

  function setMedia(root, vehicle) {
    const media = $(root, '[data-ahv-media]');
    if (!media) return;

    const image = vehicleImage(vehicle);
    if (image) {
      media.dataset.media = 'image';
      media.innerHTML = `<img src="${esc(image)}" alt="${esc(vehicleName(vehicle))}" loading="lazy" decoding="async">`;
      return;
    }

    media.dataset.media = 'fallback';
    media.innerHTML = vehicleFallbackIcon();
  }

  function vehicleFallbackIcon() {
    return `
      <svg viewBox="0 0 24 24" focusable="false" aria-hidden="true">
        <path d="M5.2 10.1 6.8 6c.3-.8 1-1.3 1.9-1.3h6.6c.9 0 1.6.5 1.9 1.3l1.6 4.1 1.2.5c.6.3 1 .9 1 1.6v4.1c0 .5-.4.9-.9.9h-1.2v.8c0 .7-.6 1.3-1.3 1.3h-.8c-.7 0-1.3-.6-1.3-1.3v-.8H8.5v.8c0 .7-.6 1.3-1.3 1.3h-.8c-.7 0-1.3-.6-1.3-1.3v-.8H3.9c-.5 0-.9-.4-.9-.9v-4.1c0-.7.4-1.3 1-1.6l1.2-.5Zm2.4-.5h8.8l-1-2.6H8.6l-1 2.6Zm-.7 4.7a1.3 1.3 0 1 0 0-2.6 1.3 1.3 0 0 0 0 2.6Zm10.2 0a1.3 1.3 0 1 0 0-2.6 1.3 1.3 0 0 0 0 2.6Z"/>
      </svg>`;
  }

  function openDialog(root) {
    const dialog = $(root, '[data-ahv-dialog]');
    if (!dialog || dialog.open) return;
    if (typeof dialog.showModal === 'function') {
      dialog.showModal();
    } else {
      dialog.setAttribute('open', '');
    }
  }

  function closeDialog(root) {
    const dialog = $(root, '[data-ahv-dialog]');
    if (!dialog || !dialog.open) return;
    if (typeof dialog.close === 'function') {
      dialog.close();
    } else {
      dialog.removeAttribute('open');
    }
  }

  function setSelect(select, label, disabled) {
    if (!select) return;
    select.innerHTML = `<option value="">${esc(label)}</option>`;
    select.disabled = Boolean(disabled);
  }

  function appendOption(select, value, label, data) {
    const option = document.createElement('option');
    option.value = value == null ? '' : String(value);
    option.textContent = label || '';
    if (data) option.dataset.vehicle = JSON.stringify(data);
    select.appendChild(option);
  }

  function selectedVehicle(select) {
    const option = select && select.selectedOptions && select.selectedOptions[0];
    if (!option || !option.dataset.vehicle) return null;
    try {
      return JSON.parse(option.dataset.vehicle);
    } catch (_) {
      return null;
    }
  }

  function renderSelected(root, vehicle) {
    const label = $(root, '[data-ahv-label]');
    const title = $(root, '[data-ahv-title]');
    const meta = $(root, '[data-ahv-meta]');
    const actions = $(root, '[data-ahv-actions]');
    const dialogActions = $(root, '[data-ahv-dialog-actions]');

    root.dataset.state = 'selected';
    setMedia(root, vehicle);
    if (label) label.textContent = root.dataset.selectedLabel || 'Véhicule sélectionné';
    if (title) title.textContent = vehicleName(vehicle);
    if (meta) meta.textContent = vehicleMeta(vehicle);
    if (actions) {
      actions.hidden = false;
      actions.innerHTML = `
        <a class="garage-header-vehicle__button" href="${esc(resultsUrl(root, vehicle))}"><span class="garage-header-vehicle__results-long">${esc(root.dataset.resultsLabel || 'Voir les produits compatibles')}</span><span class="garage-header-vehicle__results-short">Résultats</span></a>
        <button type="button" class="garage-header-vehicle__link" data-ahv-open>${esc(root.dataset.changeLabel || 'Modifier')}</button>`;
    }
    if (dialogActions) {
      dialogActions.hidden = false;
      dialogActions.innerHTML = `<button type="button" class="garage-header-vehicle__link" data-ahv-reset>${esc(root.dataset.resetLabel || 'Réinitialiser')}</button>`;
    }
  }

  function renderEmpty(root) {
    const label = $(root, '[data-ahv-label]');
    const title = $(root, '[data-ahv-title]');
    const meta = $(root, '[data-ahv-meta]');
    const form = $(root, '[data-ahv-form]');
    const actions = $(root, '[data-ahv-actions]');
    const dialogActions = $(root, '[data-ahv-dialog-actions]');

    root.dataset.state = 'empty';
    setMedia(root, null);
    if (label) label.textContent = root.dataset.emptyTitle || 'Trouvez vos injecteurs';
    if (title) title.textContent = root.dataset.selectLabel || 'Sélectionner un véhicule';
    if (meta) meta.textContent = root.dataset.emptyText || 'Sélectionnez votre marque, modèle et motorisation.';
    if (actions) {
      actions.hidden = false;
      actions.innerHTML = `<button type="button" class="garage-header-vehicle__button" data-ahv-open>${esc(root.dataset.selectLabel || 'Sélectionner un véhicule')}</button>`;
    }
    if (dialogActions) dialogActions.hidden = true;
    if (form && root.dataset.formBound === 'true') {
      const makeSelect = $(root, '[data-ahv-make]');
      const modelSelect = $(root, '[data-ahv-model]');
      const vehicleSelect = $(root, '[data-ahv-vehicle]');
      const saveButton = $(root, '[data-ahv-save]');
      if (makeSelect) makeSelect.value = '';
      setSelect(modelSelect, root.dataset.modelLabel || 'Modèle', true);
      setSelect(vehicleSelect, root.dataset.vehicleLabel || 'Motorisation', true);
      if (saveButton) saveButton.disabled = true;
    }
  }

  function bindForm(root) {
    if (root.dataset.formBound === 'true') return;
    root.dataset.formBound = 'true';

    const makeSelect = $(root, '[data-ahv-make]');
    const modelSelect = $(root, '[data-ahv-model]');
    const vehicleSelect = $(root, '[data-ahv-vehicle]');
    const saveButton = $(root, '[data-ahv-save]');
    const status = $(root, '[data-ahv-status]');
    let modelRequestId = 0;
    let vehicleRequestId = 0;

    const labels = {
      make: root.dataset.makeLabel || 'Marque',
      model: root.dataset.modelLabel || 'Modèle',
      vehicle: root.dataset.vehicleLabel || 'Motorisation',
      loading: root.dataset.loadingLabel || 'Chargement...'
    };

    function setStatus(text) {
      if (status) status.textContent = text || '';
    }

    setSelect(makeSelect, labels.loading, true);
    setSelect(modelSelect, labels.model, true);
    setSelect(vehicleSelect, labels.vehicle, true);
    if (saveButton) saveButton.disabled = true;

    api(root, '/makes')
      .then((makes) => {
        setSelect(makeSelect, labels.make, false);
        makes.forEach((make) => appendOption(makeSelect, field(make, ['id', 'Id']), field(make, ['name', 'Name'])));
        setStatus(makes.length ? '' : 'Aucune marque disponible.');
      })
      .catch((error) => setStatus(error.message));

    makeSelect && makeSelect.addEventListener('change', () => {
      const currentModelRequest = ++modelRequestId;
      vehicleRequestId += 1;
      const makeId = makeSelect.value;
      setSelect(modelSelect, labels.model, true);
      setSelect(vehicleSelect, labels.vehicle, true);
      if (saveButton) saveButton.disabled = true;
      if (!makeId) return;

      setSelect(modelSelect, labels.loading, true);
      api(root, '/models', { makeId })
        .then((models) => {
          if (currentModelRequest !== modelRequestId) return;
          setSelect(modelSelect, labels.model, false);
          models.forEach((model) => appendOption(modelSelect, field(model, ['id', 'Id']), translate(field(model, ['name', 'Name']))));
          setStatus(models.length ? '' : 'Aucun modèle disponible.');
        })
        .catch((error) => {
          if (currentModelRequest === modelRequestId) setStatus(error.message);
        });
    });

    modelSelect && modelSelect.addEventListener('change', () => {
      const currentVehicleRequest = ++vehicleRequestId;
      const makeId = makeSelect.value;
      const modelSeriesId = modelSelect.value;
      setSelect(vehicleSelect, labels.vehicle, true);
      if (saveButton) saveButton.disabled = true;
      if (!makeId || !modelSeriesId) return;

      setSelect(vehicleSelect, labels.loading, true);
      api(root, '/vehicles', { makeId, modelSeriesId })
        .then((vehicles) => {
          if (currentVehicleRequest !== vehicleRequestId) return;
          setSelect(vehicleSelect, labels.vehicle, false);
          vehicles.forEach((vehicle) => {
            appendOption(vehicleSelect, field(vehicle, ['id', 'Id']), [vehicleName(vehicle), vehicleMeta(vehicle)].filter(Boolean).join(' - '), vehicle);
          });
          setStatus(vehicles.length ? '' : 'Aucune motorisation disponible.');
        })
        .catch((error) => {
          if (currentVehicleRequest === vehicleRequestId) setStatus(error.message);
        });
    });

    vehicleSelect && vehicleSelect.addEventListener('change', () => {
      if (saveButton) saveButton.disabled = !selectedVehicle(vehicleSelect);
    });

    saveButton && saveButton.addEventListener('click', () => {
      const vehicle = selectedVehicle(vehicleSelect);
      if (!vehicle) return;
      renderSelected(root, saveVehicle(root, vehicle));
      setStatus('');
      closeDialog(root);
    });

    document.addEventListener('vehiclefitment:cleared', () => {
      modelRequestId += 1;
      vehicleRequestId += 1;
    });
  }

  function render(root) {
    const vehicle = readVehicle(root);
    if (vehicle) {
      root.hidden = false;
      renderSelected(root, vehicle);
      return;
    }

    if (root.dataset.selectedOnly === 'true') {
      root.hidden = true;
      return;
    }

    root.hidden = false;
    bindForm(root);
    renderEmpty(root);
  }

  function boot() {
    $$(document, '[data-garage-header-vehicle]').forEach(render);
  }

  document.addEventListener('click', (event) => {
    const dialog = event.target.closest('[data-ahv-dialog]');
    if (dialog && event.target === dialog) {
      const root = dialog.closest('[data-garage-header-vehicle]');
      if (root) closeDialog(root);
      return;
    }

    const open = event.target.closest('[data-ahv-open]');
    if (open) {
      const root = open.closest('[data-garage-header-vehicle]');
      if (root) {
        bindForm(root);
        openDialog(root);
      }
      return;
    }

    const close = event.target.closest('[data-ahv-close]');
    if (close) {
      const root = close.closest('[data-garage-header-vehicle]');
      if (root) closeDialog(root);
      return;
    }

    const reset = event.target.closest('[data-ahv-reset]');
    if (!reset) return;
    const root = reset.closest('[data-garage-header-vehicle]');
    if (root) closeDialog(root);
    clearVehicle();
  });

  document.addEventListener('DOMContentLoaded', boot);
  document.addEventListener('vehiclefitment:selected', boot);
  document.addEventListener('vehiclefitment:cleared', boot);
  document.addEventListener('shopify:section:load', boot);
})();
